import React from "react";
import { NavLink, Link } from "react-router-dom";
const DispatchButtons = () => {
  return (
    <div style={{ padding: '24px 20px 8px 20px' }}>
      <div style={{
        display: 'inline-flex', alignItems: 'center',
        background: '#f1f5f9', border: '1px solid #e5e7eb',
        borderRadius: 999, padding: 4, boxShadow: '0 4px 10px rgba(2,6,23,0.04)'
      }}>
        <NavLink to="/dispatcher" end
          style={({ isActive }) => ({
            textDecoration: 'none',
            color: isActive ? '#0f172a' : '#475569',
            fontWeight: 700, padding: '8px 14px', borderRadius: 999,
            background: isActive ? '#ffffff' : 'transparent',
            boxShadow: isActive ? '0 6px 12px rgba(2,6,23,0.06)' : 'none'
          })}
        >Open Jobs</NavLink>
        <NavLink to="/dispatched_order"
          style={({ isActive }) => ({
            textDecoration: 'none',
            color: isActive ? '#0f172a' : '#475569',
            fontWeight: 700, padding: '8px 14px', borderRadius: 999,
            background: isActive ? '#ffffff' : 'transparent',
            boxShadow: isActive ? '0 6px 12px rgba(2,6,23,0.06)' : 'none'
          })}
        >Dispatched Loads</NavLink>
        <NavLink to="/dilevery_order"
          style={({ isActive }) => ({
            textDecoration: 'none',
            color: isActive ? '#0f172a' : '#475569',
            fontWeight: 700, padding: '8px 14px', borderRadius: 999,
            background: isActive ? '#ffffff' : 'transparent',
            boxShadow: isActive ? '0 6px 12px rgba(2,6,23,0.06)' : 'none'
          })}
        >Delivered Loads</NavLink>
      </div>
    </div>
  );
};

export default DispatchButtons;
